import { useLocation } from "react-router-dom";

/**
 * Keeps list filters across drill-down navigation. List screens hold their filters in the query
 * string; when one navigates forward it passes `returnState(location)` as router state, which
 * records "pathname -> pathname+search" for the current screen (and every screen before it).
 * A screen further down asks `useReturnTo(path)` for a back link and gets the filtered URL the
 * user left, or the bare `path` when it was opened directly (deep link, new tab).
 */

/** Router state for a forward navigation from `location`. */
export const returnState = (location) => ({
  returnTo: {
    ...(location.state?.returnTo || {}),
    [location.pathname]: `${location.pathname}${location.search}`,
  },
});

/** Router state to carry unchanged through a same-screen `replace` navigation. */
export const keepState = (location) => location.state ?? null;

/** Resolves a bare path to the filtered URL the user last left it at, if known. */
export const resolveReturnTo = (location, path) =>
  location.state?.returnTo?.[path] || path;

/** Hook form of `resolveReturnTo`; returns a resolver for the current location. */
export const useReturnTo = () => {
  const location = useLocation();
  return (path) => resolveReturnTo(location, path);
};
